import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { getUser } from "selectors/commonSelectors";
import { hasExternalApprovals } from "utils/feature-gates";

export function ExternalApprovalsRoute({ children }: { children: ReactNode }) {
  const user = useSelector(getUser);

  if (!user?.userId) return null;

  return hasExternalApprovals(user) ? (
    children
  ) : (
    <Navigate to="/dashboard/approvals/board" replace />
  );
}
